module.exports = __webpack_public_path__ + "static/img/轮播_1.0cbfa399.jpg";